import api from './api';

const whatsappService = {
  async getSettings() {
    const response = await api.get('/v1/me/whatsapp/settings');
    return response.data;
  },

  async updateSettings(settings) {
    // settings: { enabled, templateStyle, messageNotes, notifyOnPublicCreate, notifyOnPrivateCreate,
    //             reminderEnabled, reminderHoursBefore, reminderRespectBusinessHours,
    //             reminderBusinessStart, reminderBusinessEnd }
    const response = await api.put('/v1/me/whatsapp/settings', settings);
    return response.data;
  },

  async listMessages(page = 1, pageSize = 20) {
    const response = await api.get('/v1/me/whatsapp/messages', { params: { page, pageSize } });
    return response.data;
  },

  async getCreditStatement(windowDays = 30) {
    // { entries:[{id,source,qty,remaining,createdAt,expiresAt,productName}],
    //   purchases:[{intentId,productId,productName,creditQty,priceCents,status,createdAt,fulfilledAt,
    //               method /* 'Pix'|'CreditCard'|null — null = compra antiga, era PIX */}],
    //   daily:[{date,consumed,refunded}], windowDays }
    const response = await api.get('/v1/me/whatsapp/credits/statement', { params: { windowDays } });
    return response.data;
  },

  async getModels() {
    // [{ id, name, previewCreated, previewCreatedWithNotes }]
    const response = await api.get('/v1/me/whatsapp/models');
    return response.data;
  },
};

export default whatsappService;
